import {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {useSelector} from "react-redux";
import associateServices from "../../../services";
import store from "../../../reducers/createReducers";
import GLOBAL_ACTIONS from "../../../actions/global-actions";
import '../index.css'
import GameFrameButtons from "../frame-buttons";
import Loading from "../../../components/loading";
import AuthenticationActions from "../../../actions/authentication-actions";

const PlayGameWeb = () => {
    const {authenticated} = useSelector(state => state.authenticationReducer)

    const {id} = useParams()

    const [url, setUrl] = useState('')
    const [loading, setLoading] = useState(true)

    const joinSession = async () => {
        setUrl('')
        setLoading(true)
        associateServices.joinStream({
            id
        }).then(res => {

            if (res?.status === 200) {
                setUrl(`https://viewer.millicast.com?streamId=${res?.data?.accountId}/${res?.data?.streamName}&token=${res?.data?.jwt}`)
            }
            setLoading(false)
        })

    };


    useEffect(() => {
        if (id)
            joinSession()
    }, [id])


    useEffect(() => {

        if (id && url) {
            window?.tcpSocket?.emit('join', `STREAM~${id}`)

            store.dispatch(AuthenticationActions.setStreamID(id))
        }

        return () => {
            window?.tcpSocket?.emit('leave', `STREAM~${id}`)
            store.dispatch(AuthenticationActions.setStreamID(null))

        }
    }, [url, id])


    return (
        <div className="section section--first">
            <div className="container">
                <div className="row">
                    <div className="col-12">

                        <div className="game-container-wrap frame">
                            <div className={`frame__cover hide`} id="frame-wrapper">

                                {
                                    loading ?
                                        <div className="frame__nav">
                                            <Loading/>
                                        </div> : <iframe
                                            src={url}
                                            id="game"
                                            frameBorder={0}
                                            allowFullScreen
                                            width={'100%'}
                                            height={'100%'}
                                            scrolling={'yes'}
                                        />
                                }
                            </div>


                            <GameFrameButtons
                                onClick={null}
                            />
                        </div>


                    </div>

                </div>
            </div>
        </div>
    )


}

export default PlayGameWeb
